import styled from 'styled-components'

const Wrapper = styled.div`
  width: 100%;
  text-align: ${(props) => props.align};
`

export default Wrapper
